import DropdownIcon from "@/assets/4D64FC_dropdown_icon.svg?react";
import clsxm from "@/lib/clsxm";
import {LEARN_ABOUT_US_OPTIONS} from "@/store/constants";
import useRegistrationStore from "@/store/registration";
import {useMemo, useRef, type FC} from "react";
import {useTranslation} from "react-i18next";
import {useClickAway, useKeyPressEvent, useToggle} from "react-use";

const HowDidYouHearAboutUs: FC = () => {
  const {t} = useTranslation();
  const [isOpen, toggleOpen] = useToggle(false);
  const divRef = useRef<HTMLDivElement>(null);

  useClickAway(divRef, () => toggleOpen(false));
  useKeyPressEvent("Escape", () => toggleOpen(false));

  const selectedOption = useRegistrationStore(state => state.selectedLearnAboutUs);
  const learnAboutUsExtra = useRegistrationStore(state => state.learnAboutUsExtra);

  const setValue = useRegistrationStore(state => state.setValue);

  const shouldShowExtraInput = useMemo(
    () =>
      selectedOption === "Other" ||
      selectedOption === "RecommendationFromAnotherCompany" ||
      selectedOption === "RecommendationFromInfluencer" ||
      selectedOption === "Agency",
    [selectedOption],
  );

  return (
    <>
      <div className="flex flex-col items-stretch gap-1" ref={divRef}>
        <span className="text-neutral-grey-dark text-sm font-medium">{t("howDidYouHearAboutRefluenced")}</span>
        <button
          className={clsxm(
            "hover:bg-neutral-white-dark relative flex h-14 grow items-center justify-between rounded-md border outline-hidden transition-all duration-150",
            isOpen ? "border-primary-medium-solid" : "border-neutral-grey-light",
            selectedOption ? "text-neutral-black font-medium" : "text-neutral-grey-light",
          )}
          onClick={e => {
            e.preventDefault();
            toggleOpen();
          }}>
          <span className="items-center p-4 text-center text-base">
            {selectedOption ? t("hearAboutUs" + selectedOption) : t("howDidYouHearAboutRefluenced")}
          </span>
          <DropdownIcon
            className={"mr-4 size-3 shrink-0 transition-all duration-200 " + (isOpen ? "rotate-180" : "rotate-0")}
          />
          {isOpen && (
            <div className="border-neutral-grey-light absolute inset-x-0 bottom-0 z-50 w-full -translate-y-16 overflow-hidden rounded-md border bg-white shadow-lg">
              <ul className="divide-neutral-grey-light text-neutral-black mb-0 divide-y pl-0 text-sm transition-all duration-150">
                {LEARN_ABOUT_US_OPTIONS.map(option => (
                  <li
                    onClick={() => {
                      setValue("selectedLearnAboutUs", option);
                      setValue("learnAboutUsExtra", "");
                    }}
                    value={option}
                    key={option}
                    className={
                      "hover:bg-neutral-white-dark flex cursor-pointer justify-start px-3 py-2.5 " +
                      (option === selectedOption ? "bg-primary-light-solid text-primary-dark-solid font-medium" : "")
                    }>
                    {t("hearAboutUs" + option)}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </button>
      </div>
      {shouldShowExtraInput && (
        <div className="flex flex-col items-stretch gap-1">
          <label htmlFor="learnAboutUsExtra" className="text-neutral-grey-dark text-sm font-medium">
            {t("whoOrHow")}
          </label>
          <input
            id="learnAboutUsExtra"
            type="text"
            className="border-neutral-grey-light text-neutral-black placeholder:text-neutral-grey-light focus:border-primary-medium-solid flex h-14 grow rounded-md border p-4 pr-0 outline-hidden transition-all duration-150"
            placeholder={t("optional")}
            value={learnAboutUsExtra}
            onChange={({target: {value}}) => {
              setValue("learnAboutUsExtra", value);
            }}
          />
        </div>
      )}
    </>
  );
};

export default HowDidYouHearAboutUs;
